var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { memo } from 'react';
import { styled, useTheme } from '@web/theme';
import { useFirebase } from '@web/firebase';
import { BlockControlsWrapper } from './BlockControlsWrapper';
import { usePage, usePageEdit } from '../../../ModulePage';
import { useBlockSection } from '../BlockSection';
import { Button, Fab } from '../../../Button';
import { useBlock, useBlockEdit, blockEditActions } from '../../../ModuleBlock';
import { BlockTitle } from './BlockTitle';
export var BlockControlsTop = memo(function (_a) {
    var _b, _c;
    var id = _a.id, props = __rest(_a, ["id"]);
    var theme = useTheme();
    var _d = useFirebase(), addOrUpdatePage = _d.addOrUpdatePage, addOrUpdateBlock = _d.addOrUpdateBlock;
    var data = usePage().page.data;
    var blockBg = useBlock(id).blockBg;
    var blockSectionId = useBlockSection().blockSectionId;
    var pageEdit = usePageEdit().pageEdit;
    var _e = useBlockEdit(), blockEdit = _e.blockEdit, dispatchBlockEdit = _e.dispatchBlockEdit;
    var onDelete = function () {
        var _a;
        addOrUpdatePage({
            _id: data.id,
            data: {
                blocks: __assign(__assign({}, data.blocks), (_a = {}, _a[blockSectionId] = data.blocks[blockSectionId].filter(function (bId) { return bId !== id; }), _a))
            }
        });
    };
    var onSave = function () {
        if (blockEdit.data && !blockEdit.isSaving) {
            dispatchBlockEdit({ type: blockEditActions.SAVING, isSaving: true });
            addOrUpdateBlock({ _id: id, data: blockEdit.data })
                .then(function () {
                dispatchBlockEdit({ type: blockEditActions.REMOVE });
                dispatchBlockEdit({ type: blockEditActions.SAVING, isSaving: false });
            })
                .catch(function () { return dispatchBlockEdit({ type: blockEditActions.SAVING, isSaving: false }); });
        }
    };
    var useBg = ((_b = blockEdit.data) === null || _b === void 0 ? void 0 : _b.bg) !== undefined ? (_c = blockEdit.data) === null || _c === void 0 ? void 0 : _c.bg : blockBg;
    if (!pageEdit.enabled)
        return null;
    return (React.createElement(BlockControlsWrapper, __assign({ height: "40px", style: { backgroundColor: useBg || theme.accent3rd.bg } }, props),
        React.createElement(Unpin, { onClick: onDelete, icon: "thumbtack", bg: useBg }),
        React.createElement(BlockTitle, { id: id }),
        blockEdit.data && !blockEdit.isSaving &&
            React.createElement(Save, { onClick: onSave, icon: "check", cta: true }, "Ulo\u017Eit")));
});
var Unpin = styled(Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tbackground: transparent;\n\tcolor: ", ";\n\tbackground-color: ", ";\n\tborder-radius: 4rem;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 24px;\n\theight: 24px;\n"], ["\n\tbackground: transparent;\n\tcolor: ", ";\n\tbackground-color: ", ";\n\tborder-radius: 4rem;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 24px;\n\theight: 24px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.error.bg;
}, function (_a) {
    var bg = _a.bg, theme = _a.theme;
    return bg || theme.accent3rd.bg;
});
var Save = styled(Fab)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tmargin-left: auto;\n\tfont-size: .8em;\n\tpadding: .5em 1.5em;\n\tmargin: auto;\n\tline-height: 100%;\n\tmin-height: 24px;\n"], ["\n\tmargin-left: auto;\n\tfont-size: .8em;\n\tpadding: .5em 1.5em;\n\tmargin: auto;\n\tline-height: 100%;\n\tmin-height: 24px;\n"])));
var templateObject_1, templateObject_2;
